import {
  FETCH_CATEGORIES_REQUEST,
  FETCH_CATEGORIES_SUCCESS,
  FETCH_CATEGORIES_ERROR,
} from '../constants';

export default function(state = {}, action) {
  switch (action.type) {
    case FETCH_CATEGORIES_REQUEST:
    case FETCH_CATEGORIES_ERROR:
      return state;

    case FETCH_CATEGORIES_SUCCESS:
      return action.payload;

    default:
      break;

  }
  return state;
}



// WEBPACK FOOTER //
// ./src/store/reducers/fetch_categories_reducer.js